import React, { useMemo } from 'react';
import { useSymbolInfoCapsuleConfigSlice } from 'widgets/symbolInfo/capsule/store/config/configSlice';
import useWidgetStream from 'widgets/streaming/useWidgetStream';

import { WidgetTile } from 'widgets/tiles/components/tile/WidgetTile';
import { TileToolbar } from 'widgets/tiles/components/tile/TileToolbar';
import { SymbolFromConfigOrPortfolioLinkedStatus } from 'portfolio/components/SymbolFromConfigOrPortfolioLinkedStatus';
import SymbolInfoCapsuleSettings, {
    SymbolInfoCapsuleSettingsText,
} from 'widgets/symbolInfo/capsule/SymbolInfoCapsuleSettings';
import SymbolInfoCapsuleHelp from 'widgets/symbolInfo/capsule/SymbolInfoCapsuleHelp';
import { SymbolInfoCapsuleContent } from 'widgets/symbolInfo/capsule/SymbolInfoCapsuleContent';
import { symbolInfoStreamedDataSelectors } from 'widgets/symbolInfo/store/streamSlice';
import ConfigSettingsModal from 'widgets/tiles/components/tile/ConfigSettingsModal';
import './SymbolInfoCapsule.scss';
import { useTileContext } from 'widgets/tiles/components/tile/TileContext';

const { useWidgetMessages, useWidgetStreamData } =
    symbolInfoStreamedDataSelectors;

export function SymbolInfoCapsule() {
    const { config, dispatchConfigChanged } = useSymbolInfoCapsuleConfigSlice();
    const { disableSymbolConfig } = useTileContext();

    useWidgetStream();

    const data = useWidgetStreamData();
    const messages = useWidgetMessages();

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const warning = useMemo(() => <SymbolWarning />, [config]);

    return (
        <WidgetTile className="SymbolInfoCapsule">
            <TileToolbar
                title="Symbol Info"
                settingsBody={
                    disableSymbolConfig ? undefined : (
                        <SymbolInfoCapsuleSettings />
                    )
                }
                settingsHeader={SymbolInfoCapsuleSettingsText}
                preceedingItems={<SymbolInfoCapsuleHelp />}
                messages={messages}
            />

            <div className="capsule-body">
                <SymbolFromConfigOrPortfolioLinkedStatus warning={warning}>
                    <SymbolInfoCapsuleContent data={data} />
                </SymbolFromConfigOrPortfolioLinkedStatus>
            </div>
        </WidgetTile>
    );

    function SymbolWarning() {
        return (
            <span>
                Select a symbol or specify one in the&nbsp;
                <ConfigSettingsModal
                    dispatcher={dispatchConfigChanged}
                    headerText={SymbolInfoCapsuleSettingsText}
                    triggerText={'Capsule Settings'}
                    renderSettings={(p) => <SymbolInfoCapsuleSettings {...p} />}
                />
                .
            </span>
        );
    }
}
